<template>
  <div class="login-page">
    <div class="container">
      <div class="row">
        <div class="col-lg-7" :style="backgroundStyle">
        </div>

        <div class="col-lg-5 flex-between">
          <div class=""></div>

          <div class="login-box">
            <img src="@/assets/images/phelcom/eyercloud_logo.svg" alt="">
            <div  v-if="login">
              <h5>{{ $t('login.accessAccount') }}</h5>

              <form class="">
                <div class="form-floating mb-3">
                  <input type="email" class="form-control" id="identifier" :placeholder="$t('login.email')" v-model="identifier" data-test="inputEmail">
                  <label for="identifier">{{ $t('login.email') }}</label>
                </div>

                <div class="form-floating mb-3">
                  <input :type="showPassword ? 'text' : 'password'" class="form-control" id="password" :placeholder="$t('login.password')" v-model="password" data-test="inputPassword" @keyup.enter="doLogin()">

                  <label for="password">{{ $t('login.password') }}</label>
                  <button class="btn-icon" type="button" name="button" data-test="btnShowPassword" @click="showPassword = !showPassword">
                    <IconEyePassword v-if="showPassword" />
                    <IconShowPassword v-else />
                  </button>
                </div>

                <a @click="doSwitch">{{ $t('login.forgotPassword') }}</a>

                <div>
                  <vue-recaptcha
                    v-if="isProduction"
                    ref="recaptcha"
                    @verify="onLoginVerify"
                    @expired="onExpired"
                    :sitekey=sitekey
                    size="invisible"
                    :load-recaptcha-script="true">
                  </vue-recaptcha>
                  <button class="btn btn-success" type="button" name="button" data-test="btnLogin" @click="doLogin()">{{ $t('login.login') }}</button>
                </div>

                <p>{{ $t('login.dontHaveAccount') }}</p>

                <a href="http://www.phelcom.com" target="_blank" data-test="aboutEyer">{{ $t('login.knowMoreAboutEyer') }}</a>
              </form>
            </div>

            <div class="recovery-box" v-else>
              <div v-if="!isEmailSent">
                <h5>{{ $t('login.forgotPasswordInfo') }}</h5>

                <p class="text-start">{{ $t('login.forgotPasswordInstruction') }}</p>

                <form>
                  <div class="form-floating mb-3">
                    <input class="form-control ease-all" type="email" name="recoveryEmail" :placeholder="$t('login.email')" v-model="recoveryEmail" @keydown.enter="$event.preventDefault(); doRecoverPass()">
                    <label for="recoveryEmail">{{ $t('login.email') }}</label>
                  </div>
                </form>

                <div>
                  <vue-recaptcha
                    v-if="isProduction"
                    ref="recaptcha"
                    @verify="onPwdRecoverVerify"
                    @expired="onExpired"
                    :sitekey=sitekey
                    size="invisible"
                    :load-recaptcha-script="true">
                  </vue-recaptcha>
                  <button class="btn btn-success" type="button" name="button" data-test="btndoRevocerPass" @click.stop.prevent="doRecoverPass()">{{ $t('login.sendEmail') }}</button>
                </div>

                <p>{{ $t('login.rememberedPassword') }}</p>

                <button class="btn btn-default" type="button" name="button" data-test="btnDoLoginRecover" @click="doSwitch">{{ $t('login.doLogin') }}</button>
              </div>

              <div v-else>
                <h5>{{ $t('login.recoveryEmailSent') }}</h5>

                <p>{{ $t('login.recoveryEmailInstruction') }}</p>

                <button class="btn btn-success" type="button" name="button" data-test="btnBackToLogin" @click="doSwitch">{{ $t('login.backToLogin') }}</button>
              </div>
            </div>
          </div>

          <AuthPoweredBy/>
        </div>
      </div>
    </div>

    <AuthPoweredBy/>
  </div>
</template>

<style lang="scss" scoped>
  .login-page {
    padding:                                 8px;
    height:                                  100vh;

    > .powered-box {
      display:                               none;
    }

    .container {
      height:                                100%;
      max-width:                             unset !important;
    }

    .row {
      height:                                100%;
    }

    .col-lg-7 {
      @include                               border_radius(10px);
      display:                               flex;
      flex-direction:                        column;
      justify-content:                       space-between;
      background:                            linear-gradient(252deg, #000 0%, #0D4636 100%);
      background:                            url('@/assets/images/phelcom/welcome_banner_en.png') no-repeat center bottom 30%, linear-gradient(252deg, #000 0%, #0D4636 100%);
      background-size:                       cover;
      // background:                            url('@/assets/images/phelcom/welcome_banner_en-US.png') no-repeat right center, linear-gradient(252deg, #000 0%, #0D4636 100%);
      padding:                               5rem 3rem 3rem;
    }

    .col-lg-5 {
      flex-direction:                        column;
      .login-box {
        width:                               70%;
        max-width:                           400px;
        p, a {
          font-size:                         var(--font-size-14);
          font-weight:                       400;
          line-height:                       normal;
          letter-spacing:                    0.7px;
          text-align:                        center;
          margin:                            1rem 0;
        }
        h5, a {
          color:                             var(--Brand-Primary, #1B294A);
        }
        h5 {
          font-size:                         var(--font-size-22);
          font-weight:                       300;
          margin:                            1.8rem 0;
        }
        p {
          color:                             var(--Shades-90, #101010);
          margin-top:                        1.5rem;
        }
        a {
          display:                           block;
          text-decoration:                   underline;
          cursor:                            pointer;
        }
        .btn {
          width:                             100%;
        }
        .recovery-box {
          p {
            &:not(.text-start) {
              color:                         var(--Shades-90, #101010);
            }
            &.text-start {
              font-weight:                   300;
              margin-bottom:                 1.8rem;
            }
          }
        }
      }
    }
  }
  @media (max-width: 991px) {
    .login-page {
      display:                               flex;
      flex-direction:                        column;
      justify-content:                       space-between;
      flex:                                  1;
      gap:                                   10px;
      height:                                100dvh;
      padding:                               30px 20px 10px;

      > .powered-box {
        display:                             flex;
      }

      .col-lg-7 {
        order:                               2;
      }
      .col-lg-5 {
        order:                               1;
        justify-content:                     flex-start;
        padding:                             0;

        .login-box {
          width:                             100%;

          h5 {
            font-size:                       16px;
            text-align:                      center;
            margin:                          1rem 0;
          }

          img {
            display:                         block;
            width:                           160px;
            margin:                          0 auto;
          }

          .recovery-box {
            p.text-start {
              font-size:                     12px;
              margin:                        1rem;
            }
          }
        }


        .powered-box {
          display:                           none;
        }
      }
    }
  }
</style>

<script>
  import { VueRecaptcha } from 'vue-recaptcha';
  import { useUserStore } from '@/store/user'
  import UtilService from '@/services/util-service.js';
  import AuthPoweredBy from '@/views/auth/AuthPoweredBy.vue'

  export default {
    name: 'auth-login',
    components: {
      'vue-recaptcha': VueRecaptcha,
      AuthPoweredBy,
    },
    data: () => ({
      loading: false,
      isProduction: false,
      login: true,
      msgBrowser: null,
      alert: {
        message: null,
        class: null,
      },
      identifier: null,
      password: null,
      timezone: null,
      dateTime: null,
      recoveryEmail: null,
      sitekey: process.env.VUE_APP_SITE_KEY,
      appVersion: process.env.VUE_APP_VERSION,
      isEmailSent: false,
      countryCode: 'en',
      backgroundStyle: null,
      showPassword: false,
    }),
    // computed: {
    //   backgroundStyle() {
    //     return `background: url('@/assets/images/welcome_banner_${countryCode}.png') no-repeat center bottom 30%, linear-gradient(252deg, #000 0%, #0D4636 100%)`
    //   }
    // },
    mounted() {
      console.log('axios base url', this.$axios.defaults.baseURL);
      console.log(">>>>>>>>>>>>>>>>> ENV >>>>>>>>>>>>>>>", process.env)
      this.isProduction = process.env.NODE_ENV != "development"

      //this.countryCode = new Intl.DateTimeFormat().resolvedOptions().locale || 'en-US';
      this.countryCode = UtilService.getCurrentLanguage()

      const imagePath = require(`@/assets/images/phelcom/welcome_banner_${this.countryCode}.png`);
      this.backgroundStyle = `background: url(${imagePath}) no-repeat center bottom 25%, linear-gradient(252deg, #000 0%, #0D4636 100%); background-size: cover;`


      console.log('this.isProduction:',  this.isProduction )

      const userStore = useUserStore()
      userStore.reset() // avoid reusing other clinic info

      // logic to send to password recovery screen via email link
      if (this.$route.query.forgotPassword === 'true') {
        this.login = false;
      }
      //
    },
    methods: {
      doSwitch() {
        this.alert.message = null
        this.isEmailSent = false
        this.login = !this.login
      },
      async onLoginVerify(gtoken) {
        this.resetRecaptcha()
        this.alert.message = null;
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.dateTime = moment.utc();
        let params = {
          DEFAULT_TZ: this.timezone,
          dateTime: this.dateTime, 
          identifier: this.identifier,
          password: this.password,
          recaptcha: gtoken
        }

        this.loading = true

        try {
          let sessionInfo = await this.$authService.doLogin(params)

          setTimeout(() => {
            this.loading = false
          }, 500)

          // this.allowSynchronization = sessionInfo.currentClinic.synchronizePatientData
          // if (!this.allowSynchronization) {
          //   this.$router.push("/clinic")
          // } else {
            this.$router.push("/exam")
          // }
        } catch(err) {
          if (err.response && err.response.status == 418) {
            this.$router.push("/home/limbo")
            return
          }

          if (err.response && err.response.status === 401 && err.response.data && err.response.data.message === 'PASSWORD_EXPIRED') {
            this.$message.popup(this, 'login.passwordExpired', 'operationFail', 'error')
            this.$router.push({
              name: 'change-expired-password',
              query: { email: err.response.data.userEmail || this.identifier }
            });
            return;
          }

          if (err.response && err.response.status === 401 && err.response.data && err.response.data.message === 'INVALID_CREDENTIALS') {
            this.$message.popup(this, 'login.wrongData', 'operationFail', 'error')
          }
        }
      },
      onPwdRecoverVerify: async function(gtoken) {
        this.resetRecaptcha()
        this.alert.message = null;
        let params = {
          recoveryEmail: this.recoveryEmail,
          recaptcha: gtoken
        };

        if(!this.recoveryEmail) {
          this.$message.popup(this, 'login.emptyEmail', 'operationFail', 'error')
          // this.alert = this.$message.alert(this, 'login.emptyEmail', 'danger')
          return;
        }

        this.loading = true

        try {
          await this.$authService.resetPassword(params);
          this.isEmailSent = true
          // this.$message.popup(this, 'login.checkEmailMessage', 'operationSuccess', 'success')
        } catch(err) {
          this.$message.popup(this, 'operationFail', 'operationFail', 'error')
          // this.alert = this.$message.alert(this, 'operationFail', 'danger')
        }

        this.loading = false
      },
      doLogin: async function() {
        if (!this.identifier || !this.password) {
          this.$message.popup(this, 'login.emptyData', 'operationFail', 'error')
          // this.alert = this.$message.alert(this, 'login.emptyData', 'danger')
          return
        }

        if (!this.isProduction) {
          this.onLoginVerify()
          return
        }

        this.$refs.recaptcha.execute();
      },
      doRecoverPass: async function() {
        if (!this.recoveryEmail) {
          this.$message.popup(this, 'login.emptyEmail', 'operationFail', 'error')
          // this.alert = this.$message.alert(this, 'login.emptyEmail', 'danger')
          return;
        }

        if (!this.isProduction) {
          this.onPwdRecoverVerify()
          return
        }
        this.$refs.recaptcha.execute();
      },
      onExpired: function () {
        console.log('Recaptcha Expired')
      },
      resetRecaptcha() {
        if (!this.isProduction)
          return

        this.$refs.recaptcha.reset();
      }
    }
  }
</script>
